import { gql } from '@apollo/client';

export const SET_USER_SELECTED_LOCATION = gql`
  mutation SetUserSelectedLocation($input: SetUserSelectedLocationInput!) {
    setUserSelectedLocation(input: $input) {
      countryCode
      success
    }
  }
`;
